class InteractiveGraphic {
  constructor() {
    this.triggersOpen = Array.from(document.querySelectorAll('[data-name*="trigger_open"]'));
    this.triggersClose = Array.from(document.querySelectorAll('[data-name*="trigger_close"]'));
    this.targets = Array.from(document.querySelectorAll('[data-name*="target"]'));
    this.overlays = Array.from(document.querySelectorAll('[data-name*="overlay"]'));

    this.bindEvents();
  }

  bindEvents() {
    [...this.triggersOpen, ...this.triggersClose].forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.stopPropagation();

        let id = trigger.dataset.name.split('_')[0];

        let associatedOpen = this.triggersOpen.find(el => el.dataset.name.startsWith(id));
        let associatedClose = this.triggersClose.find(el => el.dataset.name.startsWith(id));
        let associatedTargets = this.targets.filter(target => target.dataset.name.startsWith(id));
        let associatedOverlays = this.overlays.filter(overlay => overlay.dataset.name.startsWith(id));

        let isActive = trigger.classList.contains('active');

        this.closeAll();

        if (!isActive) {
          if (associatedOpen) associatedOpen.classList.add('active');
          if (associatedClose) associatedClose.classList.add('active');
          associatedTargets.forEach(target => target.classList.add('active'));
          associatedOverlays.forEach(overlay => overlay.classList.add('active'));
        }
      });
    });

    this.targets.forEach(target => {
      target.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    });

    this.overlays.forEach(overlay => {
      overlay.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    });

    document.addEventListener('click', () => {
      this.closeAll();
    });
  }

  closeAll() {
    [...this.triggersOpen, ...this.triggersClose].forEach(trigger => trigger.classList.remove('active'));
    this.targets.forEach(target => target.classList.remove('active'));
    this.overlays.forEach(overlay => overlay.classList.remove('active'));
  }
}

export default InteractiveGraphic;
